import { render, staticRenderFns } from "./HeadlineTitleText.vue?vue&type=template&id=969e4e02&scoped=true&"
import script from "./HeadlineTitleText.vue?vue&type=script&lang=js&"
export * from "./HeadlineTitleText.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineTitleText.vue?vue&type=style&index=0&id=969e4e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969e4e02",
  null
  
)

export default component.exports